import React, { useContext, useState, useEffect } from 'react';
import style from './Announcement.module.css';

import icons from '../../icons';
import urls from '../../urls';
import { AppContext } from '../../AppContext';
import OptionSelection from './OptionSelection/OptionSelection';
import ErrorSnackbar from '../ErrorSnackbar/ErrorSnackbar';
import TextButton from '../Buttons/TextButton/TextButton';

import { db } from '../../firebase';
import { collection, deleteDoc, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import IconButton from '../Buttons/IconButton/IconButton';


const Announcement = props => {
    const { user, users, page, setPage, announcements, setAnnouncements } = useContext(AppContext);

    const [saving, setSaving] = useState(false);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [error, setError] = useState({ show: false, error: "" });
    const [notificate, setNotificate] = useState(true);
    const [selectingOption, setSelectingOption] = useState(null);
    const [link, setLink] = useState({ link: "", linkText: "" });
    const [createdAt, setCreatedAt] = useState(new Date());

    const save = async () => {
        if (saving)
            return;
        
        if (!description || !title) {
            setError({ show: true, error: "Riempi tutti i campi!" })
            return;
        }
        
        setSaving(true);

        const path = props.school ? `schools/${user.school}/announcements` : `schools/${user.school}/classes/${user.class}/announcements`;
        const eventId = props.id ?? doc(collection(db, path)).id;

        setAnnouncements(oldAnnouncements => ({
            ...oldAnnouncements, [eventId]: {
                id: eventId,
                author: user.id,
                createdAt: createdAt.toString(),
                title,
                description,
                link,
                school: true,
            }
        }));

        await setDoc(doc(db, path, eventId), {
            id: eventId,
            author: user.id,
            createdAt: createdAt.toString(),
            title,
            description,
            link
        });
        
        if (!props.id)
            await fetch(urls.notifyAnnouncementAdded, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    user: user,
                    users,
                    school: true,
                    announcement: {
                        id: eventId,
                        author: user.id,
                        createdAt: createdAt.toString(),
                        title,
                        description,
                        link
                    },
                })
            });

        setSaving(false);
        setPage({ page: "home" });
    };

    const deleteAnnouncement = async () => {
        setSaving(true);
        await deleteDoc(doc(db, props.school ? `schools/${user.school}/announcements/${props.id}` : `schools/${user.school}/classes/${user.class}/announcements/${props.id}`));
        setAnnouncements(oldAnnouncements => (Object.fromEntries(Object.entries(oldAnnouncements).filter(([id, announcement]) => id !== props.id))));
        setPage({ page: "home" });
    };

    useEffect(() => {
        const fetchAnnouncement = async () => {
            const announcement = announcements[props.id];

            setTitle(announcement.title);
            setDescription(announcement.description);
            setLink(announcement.link);
            setCreatedAt(new Date(announcement.createdAt));
        };

        if (props.id)
            fetchAnnouncement();
    }, [props.id]);

    return <>
        <OptionSelection 
            option={ selectingOption }
            selectedOptions={{
                link,
            }}
            value={ 
                selectingOption === "link" ? link : null
                // selectingOption === "subject" ? subject :
                // selectingOption === "users" ? eventUsers : null  
            }
            back={ () => setSelectingOption(null) }
            select={ value => {
                switch (selectingOption) {
                    case "link":
                        setLink(value);
                        break;
                };
            } } 
            setError={ setError }
        />
        <ErrorSnackbar error={ error.error } show={ error.show } setShow={ show => setError(oldError => ({ ...oldError, show })) } />
        <main className={ style.main }>
            <div className={ style.flex }>
                <img src={ icons.arrow_left_icon } className={ style.backIcon } onClick={ () => setPage({ page: page.from || "home" }) }></img>
                { props.id ? <h2>Modifica<br></br><span style={{ color: "var(--orange)" }}>Annuncio</span></h2> : <h2>Aggiungi<br></br><span style={{ color: "var(--orange)" }}>Annuncio</span></h2> }
            </div>
            <h5 className={ style.subHeader }>Titolo annuncio</h5>
            <textarea className={ style.title } value={ title } onChange={ e => setTitle(e.target.value) }></textarea>
            <h5 className={ style.subHeader }>Descrizione annuncio</h5>
            <textarea className={ style.description } value={ description } onChange={ e => setDescription(e.target.value) }></textarea>
            <div className={ style.detailsContainer }>
                <div className={ style.detail } onClick={ () => setSelectingOption("link") }>
                    <img src={ link.link?.includes("instagram") ? icons.instagram_icon : icons.globe_icon }></img>
                    <div>
                        <h4 className={ style.detailName }>Link</h4>
                        <h4 className={ style.detailValue }>{ link.linkText || link.link || "Inserisci" }</h4>
                    </div>
                </div>
                <div className={ [style.detail, props.id && style.disabled].join(" ") } style={{ background: (notificate && !props.id) && "rgb(28, 126, 255)", position: "relative" }} onClick={ () => {
                    if (!props.id)
                        setNotificate(oldNotificate => !oldNotificate);
                } } >
                    <img src={ icons.notification_icon }></img>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <h4 className={ style.detailValue } style={{ marginTop: "auto", marginBottom: "auto", display: "block" }}>Notifica</h4>
                    </div>
                </div>
            </div>
            <TextButton loading={ saving } text="SALVA" style={{ width: "70vw", marginLeft: "auto", marginRight: "auto", marginTop: "2rem", marginBottom: "1rem", padding: ".25rem 0" }} fontSize="1.1rem" onClick={ save } />
            { props.id && <IconButton icon={ icons.trash_white_icon } loading={ saving } text="ELIMINA" background="linear-gradient(to left, rgb(150, 1, 1), rgb(255, 8, 0)" style={{ width: "70vw", marginLeft: "auto", marginRight: "auto", marginTop: "2rem", marginBottom: "1rem", padding: ".25rem 0" }} fontSize="1.1rem" onClick={ deleteAnnouncement } /> }
        </main>
    </>;
};

export default Announcement;